import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const createReferralLink = createAsyncThunk('referral/createReferralLink', async (_, { rejectWithValue }) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.post(`${process.env.REACT_APP_SERVER_API}/referrals/links/`, {}, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
}); 